<div class="neo-multi-select">

  <!-- Trigger Section -->
  <div class="trigger-container">
    <ng-container *ngIf="triggerTemplate; else defaultTrigger">
      <div [matMenuTriggerFor]="disabled ? null : optionsPanel" (menuOpened)="onOpen()" (menuClosed)="onClose()" class="w-100p">
        <ng-container [ngTemplateOutlet]="triggerTemplate"></ng-container>
      </div>
    </ng-container>

    <ng-template #defaultTrigger>
      <mat-form-field subscriptSizing="dynamic" [hideRequiredMarker]="true" [appearance]="'outline'"
        [class.errored]="hasError" [matMenuTriggerFor]="disabled ? null : optionsPanel" (menuOpened)="onOpen()"
        (menuClosed)="onClose()">
        <mat-label class="ellipsify" [hidden]="!effectiveLabelText" [ngClass]="triggerLabelClass">
          {{ effectiveLabelText }}
        </mat-label>
        <mat-select [required]="required && !value.length" [disabled]="disabled"
          [placeholder]="placeholder">
        </mat-select>
        <div *ngIf="showSelectedCount" class="selected-count">{{ selectedCount || '' }}</div>
        <input matInput [formControl]="triggerCtrl" class="d-none" />
        @if (hint) {
          <mat-hint class="neo-multi-select-hint" role="status">
            <mat-icon aria-hidden="true">info_outline</mat-icon>{{ hint }}
          </mat-hint>
        }
      </mat-form-field>
    </ng-template>
  </div>

  <!-- Dropdown Panel -->
  <mat-menu class="neo-multi-select-panel" #optionsPanel="matMenu" [ngClass]="panelClass"
    [backdropClass]="backdropClass">

    @if (!hideSelectAll || !hideSearch) {
      <div class="ctrls-container" (click)="$event.stopPropagation(); $event.preventDefault()">
        @if (!hideSelectAll) {
          <div class="select-all-ctrl">
            <mat-checkbox [checked]="allSelected" [indeterminate]="allSelected === null"
              [color]="allSelected === null ? selectAllIndeterminateColor : selectAllCheckedColor"
              [disabled]="!filteredOptions.length"
              (change)="toggleSelectAll()" (click)="$event.stopPropagation()">
              {{ selectAllLabel }}
            </mat-checkbox>
          </div>
        }

        @if (!hideSearch) {
          <mat-form-field class="search-ctrl" appearance="outline" subscriptSizing="dynamic">
            <input #searchInput matInput [formControl]="searchCtrl" [placeholder]="searchPlaceholder"
              (keydown)="$event.stopPropagation()" />
            <mat-icon matSuffix [class.clickable]="searchCtrl.value?.length"
              (click)="searchCtrl.value?.length && searchCtrl.reset()">
              {{ searchCtrl.value?.length ? 'clear' : 'search' }}
            </mat-icon>
          </mat-form-field>
        }
      </div>

      <mat-divider></mat-divider>
    }

    <div class="options-container" [ngClass]="optionsContainerClass" (click)="$event.stopPropagation()">
      @for (option of filteredOptions; track $index) {
        <div mat-menu-item (click)="toggleSelection(option); $event.stopPropagation();">
          <mat-checkbox [checked]="findIndex(includeResetApplyButtons ? internalValue : value, option) > -1" [ngClass]="{ 'ellipsify': ellipsifyOptionText }"
            [matTooltip]="option[optionLabel]" matTooltipClass="dark-tooltip" [matTooltipPosition]="optionTooltipPosition"
            [matTooltipDisabled]="!ellipsifyOptionText" >
            {{ option[optionLabel] }}
          </mat-checkbox>
        </div>
      }
    </div>
    @if (includeResetApplyButtons) {
      <mat-divider></mat-divider>

      <div class="reset-apply-container" (click)="$event.stopPropagation(); $event.preventDefault()">
        <neo-button text="Reset" buttonType="secondary" (click)="onResetClicked()"></neo-button>
        <neo-button text="Apply" buttonType="primary" (click)="onApplyClicked()"></neo-button>
      </div>
    }

    @if (!filteredOptions.length) {
      <ng-container [ngTemplateOutlet]="nothingToShow"></ng-container>
    }

  </mat-menu>

</div>

<ng-template #nothingToShow>
  <div class="no-data-found neo-multi-select" (click)="$event.stopPropagation(); $event.preventDefault()">
    <mat-icon>search_off</mat-icon>
    <span>Nothing to show.</span>
  </div>
</ng-template>